import React from 'react'
import KeylessCipherTable from './KeylessCipherTable';

const KeylessCipherEncryption = ({ plainText, cipherText, positions, rails, selectedCharCol }) => {

    var plainTextArray = plainText.split("");
    var cipherTextArray = cipherText.split("");

    return (
        <div>
            <p style={{ textAlign: "left", fontSize: "20px", fontWeight: "bold", margin: "40px 0 10px 0" }}>Encryption</p>

            <div style={{ textAlign: "left", display: "flex" }}>

                <div style={{ display: "inline" }}>
                    <div className='wrapper'>
                        <KeylessCipherTable text={plainTextArray} rails={rails} colPositions={positions} selectedCharCol={selectedCharCol}></KeylessCipherTable>
                    </div>
                    <p style={{ fontSize: 19, display: selectedCharCol !== '' ? "inline" : "none"}} ><span style={{ fontWeight: "bold" }}>Cipher Text :</span>{cipherText}</p>
                </div>
            </div>
        </div>
    )
}

export default KeylessCipherEncryption